import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Compass from './icon-compass.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Compass {...validProps} />;
}
SvgComponent.iconName = 'Compass';

/**
 * @deprecated This is a legacy icon
 */
export const CompassIcon = svgIconWrapper(SvgComponent);
